import React from 'react'
import styled from '@emotion/styled'
import { Button } from '@labsavvyapp/components'
import { OrdersetCategoryProps } from '../../OrdersetCategory'

const OrdersetCategoryFooterLayout = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
  align-content: center;
`

const LeftButtons = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  justify-content: flex-start;
  gap: 10px;
  align-items: center;
  align-content: center;
`

const RightButtons = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  justify-content: flex-end;
  gap: 10px;
  align-items: center;
  align-content: center;
`

interface OrdersetCategoryFooterProps {
  isSaveCategoryButtonDisabled: boolean
  handleRemoveOrdersetCategory: () => void
}

export const OrdersetCategoryFooter = (props: OrdersetCategoryFooterProps) => {
  const { isSaveCategoryButtonDisabled, handleRemoveOrdersetCategory } = props

  return (
    <OrdersetCategoryFooterLayout>
      <LeftButtons>
        {/* <Button radius="xl" size="xs" uppercase variant="outline" onClick={handleRemoveOrdersetCategory}>
          Remove Category
        </Button> */}
      </LeftButtons>
      <RightButtons></RightButtons>
    </OrdersetCategoryFooterLayout>
  )
}
